/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import translate from '@/lib/intl/translate';

type DeleteButtonProps = IconButtonProps & {
  iconClassName?: string;
  label?: string;
  showTooltip?: boolean;
};

const DeleteButton = React.forwardRef<HTMLButtonElement, DeleteButtonProps>(
  (
    {
      iconClassName = '',
      label = translate('DELETE'),
      showTooltip = true,
      ...props
    },
    ref,
  ) => {
    const btn = (
      <IconButton
        {...props}
        color="primary"
        aria-label={label}
        edge="start"
        ref={ref}
      >
        <DeleteIcon className={iconClassName} />
      </IconButton>
    );

    if (showTooltip && label) {
      return <Tooltip title={label}>{btn}</Tooltip>;
    }

    return btn;
  },
);

export default DeleteButton;
